import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { Avatar, Box, Typography } from '@mui/material';
import type { FC } from 'react';

import { useUserProfile } from 'contexts/UserProfileContext';
import { getUserPlaceholderName } from 'helpers/user';

import UserProfileLoader from './UserProfileLoader';

const dataRowSx = {
  display: 'flex',
  alignItems: 'center',
  mt: 3,
  gap: 2,
};

const UserProfile: FC = () => {
  const { userProfile, isLoadingUserProfile } = useUserProfile();

  if (isLoadingUserProfile) {
    return <UserProfileLoader />;
  }

  const placeholder = getUserPlaceholderName(userProfile?.firstname, userProfile?.lastname);

  return (
    <Box>
      <Avatar
        src={userProfile?.photoUrl}
        sx={{
          width: 200,
          height: 200,
          fontSize: '4rem',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          mt: 2,
        }}
      >
        {placeholder}
      </Avatar>

      <Box sx={{ mt: 3 }}>
        <Box sx={dataRowSx}>
          <PersonOutlineIcon color="action" />
          <Typography variant="body1" color="text.primary">
            {userProfile?.displayName}
          </Typography>
        </Box>

        <Box sx={dataRowSx}>
          <EmailOutlinedIcon color="action" />
          <Typography variant="body1" color="text.primary">
            {userProfile?.email}
          </Typography>
        </Box>

        <Box sx={dataRowSx}>
          <PhoneOutlinedIcon color="action" />
          <Typography variant="body1" color="text.primary">
            {userProfile?.phoneNumber && `+${userProfile.phoneNumber}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default UserProfile;
